import React, { FC } from 'react'
import classNames from 'classnames'
import { motion } from 'framer-motion'
import { getImage } from '../../../../app/utlis/imageConstants'
import DynamicSVG from '../../../atoms/DynamicSvg/DynamicSvg'

interface WebAppIdeaProjectsProps {
    webAppData: any
}

const WebAppIdeaProjects: FC<WebAppIdeaProjectsProps> = ({ webAppData }) => {
    // Animation variants for project cards
    const projectAnimation = {
        hidden: { opacity: 0 },
        visible: (i: number) => ({
            opacity: 1,
            transition: {
                delay: i * 0.1,
                duration: 0.8,
                ease: "easeOut"
            }
        })
    };

    // Animation variants for image
    const imageAnimation = {
        hidden: { opacity: 0, scale: 0.9 },
        visible: {
            opacity: 1,
            scale: 1,
            transition: {
                duration: 0.1,
                ease: "easeOut"
            }
        }
    };

    // Animation variants for text
    const textAnimation = {
        hidden: { opacity: 0, x: 20 },
        visible: {
            opacity: 1,
            x: 0,
            transition: {
                duration: 0.2,
                ease: "easeOut"
            }
        }
    };

    return (
        <div>
            <div className='flex flex-col gap-10 bg-darkGreyPrimary mt-8'>
                {webAppData.WebAppIdeaProjectsData.map((projects: any, index: number) => {
                     let img = getImage(projects.image ?? "") ?? "";
                    return (
                        <motion.div 
                            key={index}
                            className={`flex flex-col justify-center ${index % 2 === 0 ? 'md:flex-row-reverse' : 'md:flex-row'} px-6 sm:px-10 md:px-20 lg:px-40 gap-6 md:gap-10`}
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: false, amount: 0.3 }}
                            custom={index}
                            variants={projectAnimation}
                        >
                            <motion.div 
                                className={`w-full md:w-[30%] overflow-hidden bg-darkGreyTernary`}
                                variants={imageAnimation}
                                whileHover={{ scale: 1.05 }}
                                transition={{ type: "spring", stiffness: 200 }}
                            >
                                {/* <img src={projects.image} className='w-full p-4 md:p-8' /> */}
                                <DynamicSVG color='#fff' size='w-full h-full p-4 md:p-8'>{img}</DynamicSVG>
                            </motion.div>
                            <motion.div 
                                className={classNames('flex flex-col w-full md:w-2/5', `justify-center mt-4 md:mt-0`)}
                                variants={textAnimation}
                            >
                                <div className={classNames('text-[#E0E0E0] text-base md:text-lg pt-2 md:pt-4', `text-start md:text-${projects.text}`)}>{projects.subtitle}</div>
                            </motion.div>
                        </motion.div>
                    )
                })}
            </div>
        </div>
    )
}

export default WebAppIdeaProjects
